"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stallion = void 0;
var vpt_abr_network_estimator_1 = require("@sky-uk-ott/vpt-abr-network-estimator");
var network_estimation_types_1 = require("@sky-uk-ott/vpt-abr-network-estimator/lib/network-estimation-types");
var abr_types_1 = require("../../abr-types");
var THROUGHPUT_SAFETY_FACTOR = 1;
var LATENCY_SAFETY_FACTOR = 1.25;
var Stallion = /** @class */ (function () {
    function Stallion(logger, bandwidthEstimator, latencyEstimator, config) {
        this.bandwidthEstimator = bandwidthEstimator;
        this.latencyEstimator = latencyEstimator;
        this.shouldWaitForBandwidth = true;
        this.tracksAscending = [];
        this.logger = logger.withContext('Stallion');
        var defaultConfig = {
            throughputSafetyFactor: THROUGHPUT_SAFETY_FACTOR,
            latencySafetyFactor: LATENCY_SAFETY_FACTOR,
            latencySmoother: { type: vpt_abr_network_estimator_1.SmootherType.MEAN },
            bandwidthSmoother: { type: vpt_abr_network_estimator_1.SmootherType.MEAN },
        };
        this.config = __assign(__assign(__assign({}, defaultConfig), config), { bandwidthSmoother: __assign(__assign({}, defaultConfig.bandwidthSmoother), config === null || config === void 0 ? void 0 : config.bandwidthSmoother) });
        this.logger.info('Using config: ', this.config);
        this.standardDeviationBandwidthAggregator = this.bandwidthEstimator.getStatisticalAggregator({
            type: network_estimation_types_1.StatisticalAggregatorType.STANDARD_DEVIATION,
        });
        this.meanBandwidthSmoother = this.bandwidthEstimator.getSmoother(this.config.bandwidthSmoother);
        this.meanLatencySmoother = this.latencyEstimator.getSmoother(this.config.latencySmoother);
        this.standardDeviationLatencyAggregator = this.latencyEstimator.getStatisticalAggregator({
            type: network_estimation_types_1.StatisticalAggregatorType.STANDARD_DEVIATION,
        });
    }
    Stallion.prototype.init = function () { };
    Stallion.prototype.getRecommendedTracks = function (nextSegmentDurationSeconds) {
        var meanBitrate = this.meanBandwidthSmoother.getValue();
        var standardDeviationBitrate = this.standardDeviationBandwidthAggregator.getValue() || 0;
        var meanLatency = this.meanLatencySmoother.getValue() || 0;
        var standardDeviationLatency = this.standardDeviationLatencyAggregator.getValue() || 0;
        var bitrate = meanBitrate - this.config.throughputSafetyFactor * standardDeviationBitrate;
        this.logger.verbose('calculated bitrate', bitrate);
        var latency = meanLatency + this.config.latencySafetyFactor * standardDeviationLatency;
        this.logger.verbose('calculated latency', latency);
        // This should ideally be the size of the next segment as Stallion is designed for
        // low latency streaming. But this is the best solution in the mean time.
        var segmentDuration = nextSegmentDurationSeconds;
        if (latency) {
            latency = latency / 1000;
            if (latency > segmentDuration) {
                bitrate = 0;
            }
            else {
                var deadTimeRatio = latency / segmentDuration;
                bitrate = bitrate * (1 - deadTimeRatio);
            }
        }
        this.logger.verbose('recommended bitrate', bitrate);
        return this.getTrack(bitrate);
    };
    Stallion.prototype.getTrack = function (suggestedBandwidth) {
        if (suggestedBandwidth === void 0) { suggestedBandwidth = 0; }
        var tracksDescending = this.tracksAscending.slice().reverse();
        var trackIndex = tracksDescending.findIndex(function (track) {
            return track.combinedBandwidth <= suggestedBandwidth;
        });
        if (trackIndex === -1) {
            return this.tracksAscending[0];
        }
        return tracksDescending[trackIndex];
    };
    Stallion.prototype.setTracksAscending = function (tracksAscending) {
        this.tracksAscending = tracksAscending;
    };
    Stallion.prototype.notifiedPlaybackRateChange = function () { };
    Object.defineProperty(Stallion.prototype, "name", {
        get: function () {
            return abr_types_1.AbrType.STALLION;
        },
        enumerable: false,
        configurable: true
    });
    Stallion.prototype.destroy = function () {
        this.meanBandwidthSmoother.unregister();
        this.standardDeviationBandwidthAggregator.unregister();
        this.meanLatencySmoother.unregister();
        this.standardDeviationLatencyAggregator.unregister();
    };
    return Stallion;
}());
exports.Stallion = Stallion;
